export default __webpack_public_path__ + "static/media/logo (2).61a930df.png";